import { Container } from 'react-bootstrap';
import TitleCard from './TitleCard';

const Address = ({ values: { address, city, state, zip } }) => {
  let addComma = !!city && !!state;
  return (
    <>
      <TitleCard title="Address" cName="address" headerFontSize="1.4rem">
        <Container aria-label="address-lines" className="p-0">
          {address} <br /> {city}
          {addComma ? ',' : ''} {state} {zip}
        </Container>
      </TitleCard>
    </>
  );
};

export default Address;
